import React from 'react';
import { Link } from 'react-router';
import Sidebar from '../components/Sidebar';
import { COMMAND } from '../command';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../models/user/actions';
import Store from '../library/M2Store';

class SupportController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dark_mode: (Store.get('m2darkmode') && Store.get('m2darkmode') == 'dark') ? true : false,
            problem: '',
            message: ''
        };
    }

    __problemChangeHandler(event) {
        this.setState({problem: event.target.value});
    }


    __messageChangeHandler(event) {
        this.setState({message: event.target.value});
    }

    __formSubmitHandler(event) {
        event.preventDefault();
        let info = {
            problem: this.state.problem,
            message: this.state.message
        };
        let errors = false;
        if(!info.problem) {
            alert('Пожалуйста выберете категорию проблемы');
            errors = true;
        }

        if(!info.message) {
            alert('Пожалуйста опишите вашу проблему');
            errors = true;
        }

        if(!errors) {
            this.props.actions.sendFeedback(info);
            //send to server
            this.setState({
                message: ''
            });
        }
    }


    componentWillReceiveProps(p) {
        if(p.answer && p.answer.state == 'FINISH_SEND_FEEDBACK') {
            alert('Ваше сообщение успешно отправлено');
        }
    }

    __setDarkMode(event) {
        event.preventDefault();
        let dark_mode = !this.state.dark_mode;
        if(dark_mode) {
            Store.set('m2darkmode', 'dark');
        } else {
            Store.remove('m2darkmode');
        }
        this.setState({dark_mode: dark_mode});
    }

    __commandProfile(profile) {
        let style = {backgroundImage: "url('"+profile.avatar+"')"};
        return (
            <div className="m2profile_support" key={profile.name}>
                <div className="m2profile_avatar" style={style}></div>
                <div className="m2profile_info">
                    <div className="m2profile_info_name">{profile.name}</div>
                    <div className="m2profile_info_position">{profile.position}</div>
                    <div className="m2profile_email"><Link href={"mailto:" + profile.mail}>{profile.mail}</Link></div>
                </div>
            </div>
        );
    }


    render() {
        let className = ['m2controller', 'm2controller__feed', 'm2controller_support'];
        let svg_logo = '<use opacity="0.4" xlink:href="#icon-logo"></use>';

        let items = [];

        COMMAND.map(item => items.push(this.__commandProfile(item)));

        if(this.state.dark_mode) {
            className.push('m2dark_mode');
        }

        return (
            <div className={className.join(' ')}>
                <div className="m2sidebar">
                    <Sidebar darkmode={this.__setDarkMode.bind(this)}/>
                </div>
                <div className="m2content">
                    <div className="m2content__header">
                        <div className="header__logo">
                            <svg width="145px" height="43px" dangerouslySetInnerHTML={{__html: svg_logo}}></svg>
                        </div>
                    </div>
                    <div className="m2content__container m2content__full_container m2support_full_container">
                        <div className="m2support_container_content">
                            <div className="m2support_title">Команда</div>
                            <div className="m2support_command_container">
                                {items}
                            </div>
                            <div className="m2support_title">Служба поддержки</div>
                            <div className="m2support_info_title">Если у вас возникли вопросы по использованию продукта - напишите нам!</div>
                            <div className="m2support_info_form">
                                <form method="POST" onSubmit={this.__formSubmitHandler.bind(this)}>
                                    <div className="m2support_form_title">Категория проблемы</div>
                                    <div className="m2support_form_row">
                                        <select name="value" onChange={this.__problemChangeHandler.bind(this)}>
                                            <option value="">Выберете категорию</option>
                                            <option value="Некорректная работа">Некорректная работа</option>
                                            <option value="Не хватает функциональности">Не хватает функциональности</option>
                                        </select>
                                    </div>
                                    <div className="m2support_form_title">Опишите вашу проблему</div>
                                    <div className="m2support_form_row">
                                        <textarea onChange={this.__messageChangeHandler.bind(this)} name="message" placeholder="Например: у меня не работает поиск"></textarea>
                                    </div>
                                    <div className="m2support_form_row">
                                        <button type="submit">Отправить письмо</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    answer: state.UserReducer
});


const mapDispatchProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchProps
)(SupportController);


// WEBPACK FOOTER //
// ./src/controllers/SupportController.js